/**
 * Company: SPHMedia
 * Description: [GE Live blog]
 */
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

type GELiveBlogStyleProps = {
  wrapperStyle?: string;
};

type GELiveBlogProps = {
  seasonalLiveBlogContent: string;
  styles?: GELiveBlogStyleProps;
};

/**
 * SeasonalLiveBlog
 * Description: [GE 24LiveBlog widget]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function LiveBlog({
  seasonalLiveBlogContent,
  styles,
}: GELiveBlogProps): ReactElement {
  return (
    <div
      className={twMerge(
        "h-[500px] xl:w-[300px] xl:h-full flex flex-col border-red-100 border-2",
        styles?.wrapperStyle,
      )}
    >
      <div className="text-text-inverse text-[15px] font-bold bg-red-100 p-xs">
        {`Blog BH`}
      </div>
      <div
        className="h-full overflow-scroll"
        dangerouslySetInnerHTML={{ __html: seasonalLiveBlogContent }}
      />
    </div>
  );
}
